<p-dialog
  header="Hide Job?"
  [(visible)]="rejectJobDialogVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    Select a reason for hiding this
    {{ job ? (job.buyItNowPrice | currency : 'GBP' : 'symbol' : '1.2-2') : '' }} job
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row">
    <div style="clear: both"></div>
    <div *ngFor="let reason of rejectReasons" class="reject-reason">
      <p-radioButton
        [name]="reason.reason"
        [id]="reason.id"
        [label]="reason.reason"
        [value]="reason"
        [(ngModel)]="rejectReason"
      ></p-radioButton>
    </div>
    <div *ngIf="rejectReason?.requireText">
      <textarea
        pInputTextarea
        [(ngModel)]="rejectText"
        style="width: 100%; height: 150px"
        placeholder="Please specify other reason*"
      ></textarea>
    </div>
  </div>
  <div
    style="
      display: flex;
      margin-top: 20px;
      width: 100%;
      justify-content: space-evenly;
      align-items: center;
      flex-direction: row;
      flex-wrap: nowrap;
    "
  >
    <button
      type="button"
      [disabled]="rejectReason == null || (rejectReason?.requireText && !rejectText)"
      class="ui-button-danger"
      pButton
      icon="fa ui-icon-trash"
      (click)="rejectJob()"
      label="Yes, hide job"
      style="width: 100%"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="No, cancel"
      (click)="cancelRejectJob()"
      style="width: 100%"
    ></button>
  </div>
</p-dialog>
